import React, { useState, useEffect, useCallback } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { useToast } from "../context/ToastProvider";

import AdminForm from "../components/AdminForm";
import PreviewAdminContent from "../components/PreviewAdminContent";
import { hasPermission } from "../utils/permissions";
import { useAuth } from "../context/AuthContext";


export default function AdminDelivery() {
const { permissions, hasPermission } = useAuth();

const canWrite = hasPermission("delivery:write");

  const token = localStorage.getItem("token");
  const { showToast } = useToast();

  const deliveryURL = `${process.env.REACT_APP_API_URL}/api/delivery/admin`;

  /* ===================== STATE ===================== */
  const [regions, setRegions] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [form, setForm] = useState({
    name: "",
    salary: null,
    is_active: true
  });

  const [validationErrors, setValidationErrors] = useState({});

  /* ===================== FETCH ===================== */
 const fetchData = async () => {
    setLoading(true);

    try {
      const res = await fetch(deliveryURL, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();
      setRegions(Array.isArray(data) ? data : []);
    } catch (err) {
      showToast(`Fetch error: ${err}`, "danger");
    } finally {
      setLoading(false);      
    }
  };

  useEffect(() => {
  if (!token) return;

 

  fetchData();
}, [token, deliveryURL, showToast]);
  /* ===================== FORM HELPERS ===================== */

  const resetForm = () => {
    setEditingId(null);
    setForm({
      name: "",
      salary: null,
      is_active: true
    });
  };

  const handleInputChange = (name, value) => {
    setForm(prev => ({ ...prev, [name]: value }));
    if (validationErrors[name] === false) {
      setValidationErrors(prev => ({ ...prev, [name]: true }));
    }
  };

  /* ===================== EDIT ===================== */

  const startEditing = (region) => {

    setEditingId(region.id);

    setForm({
      name: region.name || "",
      salary: region.salary || "",
      is_active: region.is_active ?? true
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ===================== SUBMIT ===================== */

  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsSaving(true);

    const payload = {
      name: form.name,
      salary: Number(form.salary),
      is_active: form.is_active
    };

    try {

      const res = await fetch(
        editingId ? `${deliveryURL}/${editingId}` : deliveryURL,
        {
          method: editingId ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        }
      );

      if (!res.ok) {
        showToast("Save failed", "danger");
        return;
      }

      resetForm();
      fetchData();
      showToast("Saved successfully");

    } catch (err) {
      showToast(`Save error: ${err}`, "danger");
    } finally {
      setIsSaving(false);
    }
  };

  /* ===================== FORM FIELDS ===================== */

  const deliveryFields = [
    {
      controlId: "name",
      name: "name",
      label: "Region Name",
      type: "text",
      required: true,
      row: 1,
      colWidth: 4
    },
    {
      controlId: "salary",
      name: "salary",
      label: "Delivery salary ($)",
      type: "number",
      required: true,
      row: 1,
      colWidth: 4
    },
    {
      controlId: "is_active",
      name: "is_active",
      label: "Active",
      type: "checkbox",
      row: 1,
      colWidth: 4
    }
  ];

  /* ===================== RENDER ===================== */

  return (
    <div className="material-container">

        {canWrite &&  (
      <Form className="p-3 br-gray-l brr" onSubmit={handleSubmit}>

        <AdminForm
          fields={deliveryFields}
          formData={form}
          onChange={handleInputChange}
          validation={validationErrors}
          canWrite={canWrite}
        />

        <div className="mt-3 d-flex gap-2">
          <Button type="submit" variant="primary" disabled={isSaving}>
            {isSaving
              ? <Spinner size="sm" />
              : editingId
                ? "Save Changes"
                : "Add Region"}
          </Button>

          <Button variant="secondary" onClick={resetForm}>
            Cancel
          </Button>
        </div>
      </Form>
)}
<hr />

      {loading ? (
        <p>⏳ Loading...</p>
      ) : (
        <div className="br-gray-l p-2 brr">

          <PreviewAdminContent
            materials={regions}
            editingId={editingId}
            startEditing={startEditing}
            deleteMaterial={() => {}}
            canDelete={false}
            canWrite={canWrite}
          />

        </div>
      )}

    </div>
  );
}